import React from "react";
import styles from "./styles.module.scss";
import nullFeedIcon from "../../../../public/images/null-booking-logs.png";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";

const NoBookingLogs: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <img src={nullFeedIcon} alt="null result" />
      <div className={styles.text}>
        <h3 className={cls(styles.title, "bold")}>{t("No booking logs")}</h3>
        <p className={styles.description}>
          {t("You don't have any booking logs yet")}
        </p>
      </div>
    </div>
  );
};

export default NoBookingLogs;
